import angular from 'angular';
import $ from 'jquery';
import template from './reminderView.html';

export class ReminderComponent {
    initDatePicker() {
        $('.datetimepicker')
            .datepicker({
                format: 'dd/mm/yyyy',
                maxViewMode: 0,
                orientation: 'bottom right',
            });
    }
}

export const ReminderComponentConfiguration = {
    template,
    controller: ReminderComponent,
    controllerAs: 'reminderCtrl',
};

angular
    .module('TALENYA-FE')
    .component('reminderComponent', ReminderComponentConfiguration);
